module.exports = __webpack_public_path__ + "img/20180815_151538_153.1e0b68c0.jpg";